// import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
// import styles from './BusinessStep.module.css';
// import { validateField } from "../../utils/validation";
// import { businessTypes } from "../../lib/businessCategories";

// const StepOne = forwardRef(({ data, updateData, setIsFocused, onBusinessTypeChange }, ref) => {
//     const [search, setSearch] = useState(data?.businessSubtype || data?.businessType || "");
//     const [showList, setShowList] = useState(false);
//     const [error, setError] = useState("");
//     const [touched, setTouched] = useState(false);
//     // Load from data prop
//     useEffect(() => {
//         if (data?.businessSubtype) {
//             setSearch(data.businessSubtype);
//         } else if (data?.businessType) {
//             setSearch(data.businessType);
//         }
//     }, [data?.businessSubtype, data?.businessType]);

//     // Build a flattened list with both types and subtypes (NO DUPLICATES)
//     const buildSearchableList = () => {
//         const items = [];
//         const seen = new Set(); // Track already added items

//         businessTypes.forEach((bt) => {
//             const mainType = bt.type;

//             // Add all subtypes FIRST
//             if (bt.subtypes && bt.subtypes.length > 0) {
//                 bt.subtypes.forEach((sub) => {
//                     const key = sub.toLowerCase();
//                     if (!seen.has(key)) {
//                         seen.add(key);
//                         items.push({
//                             display: sub,
//                             type: mainType,
//                             subtype: sub,
//                             isMainType: false
//                         });
//                     }
//                 });
//             }

//             // Add main type ONLY if it's NOT already in subtypes
//             const mainTypeKey = mainType.toLowerCase();
//             if (!seen.has(mainTypeKey)) {
//                 seen.add(mainTypeKey);
//                 items.push({
//                     display: mainType,
//                     type: mainType,
//                     subtype: null,
//                     isMainType: true
//                 });
//             }
//         });

//         return items;
//     };

//     const searchableList = buildSearchableList();

//     // Filter based on search
//     const filteredList = searchableList.filter((item) =>
//         item.display.toLowerCase().includes(search.toLowerCase())
//     );

//     const isNewCategory = search.trim() !== "" && filteredList.length === 0;

//     const handleChange = (value) => {
//         const noSpace = value.replace(/\s/g, '');
//         setSearch(noSpace);

//         // User type kare toh sab clear karo
//         if (data.businessType) {
//             updateData({
//                 businessType: '',
//                 businessSubtype: '',
//                 customBusiness: '',
//             });
//             if (onBusinessTypeChange) {
//                 onBusinessTypeChange(1); // Step 2 & 3 bhi clear
//             }
//         }
//         if (touched) {
//             const err = validateField('businessType', noSpace);
//             setError(err || "");
//         }
//     };

//     // Handle selection
//     const handleSelect = (item) => {
//         // Check if business type actually changed
//         const previousType = data.businessType;
//         const hasChanged = previousType && previousType !== item.type;

//         if (hasChanged) {
//             // Trigger reset for subsequent steps
//             if (onBusinessTypeChange) {
//                 onBusinessTypeChange(1);
//             }
//         }

//         setSearch(item.display);
//         setShowList(false);
//         setIsFocused(false);
//         setError("");

//         // Save both type and subtype
//         updateData({
//             businessType: item.type,           // Parent category
//             businessSubtype: item.subtype,     // Selected subtype (or null if main type)
//             customBusiness: ""                 // Clear custom if selecting from list
//         });
//     };

//     // Handle new custom business
//     const handleSelectNew = () => {
//         const hasChanged = data.businessType && data.businessType !== search;

//         if (hasChanged) {

//             if (onBusinessTypeChange) {
//                 onBusinessTypeChange(1);
//             }
//         }

//         setSearch(search);
//         setShowList(false);
//         setIsFocused(false);
//         setError("");

//         updateData({
//             businessType: search,
//             businessSubtype: null,
//             customBusiness: search
//         });
//     };

//     // Expose validate method to parent
//     useImperativeHandle(ref, () => ({
//         validate: () => {
//             setTouched(true);
//             const err = validateField('businessType', search);
//             setError(err || "");

//             if (!err) {
//                 // Check if it's a valid selection from list
//                 const matchedItem = searchableList.find(
//                     (item) => item.display.toLowerCase() === search.toLowerCase()
//                 );

//                 if (matchedItem) {
//                     // Update with matched item
//                     const hasChanged = data.businessType && data.businessType !== matchedItem.type;

//                     updateData({
//                         businessType: matchedItem.type,
//                         businessSubtype: matchedItem.subtype,
//                         customBusiness: ""
//                     });

//                     if (hasChanged && onBusinessTypeChange) {
//                         setTimeout(() => onBusinessTypeChange(1), 0);
//                     }
//                 } else {
//                     // Custom business
//                     const hasChanged = data.businessType && data.businessType !== search;

//                     updateData({
//                         businessType: search,
//                         businessSubtype: null,
//                         customBusiness: search
//                     });

//                     if (hasChanged && onBusinessTypeChange) {
//                         setTimeout(() => onBusinessTypeChange(1), 0);
//                     }
//                 }

//                 return true;
//             }
//             return false;
//         }
//     }));

//     return (
//         <>
//             <div className={styles.titleBar}>
//                 <h4 className={styles.lightTitle}>What type of</h4>
//                 <h5 className={styles.boldTitle}>business is this?</h5>
//                 <p className={styles.subtitle}>
//                     This helps your AI receptionist <b className={styles.boldText}>answer calls</b> more accurately.
//                 </p>
//             </div>

//             <div className={styles.searchBox}>
//                 {search === "" && (
//                     <img src="svg/Search-Icon.svg" alt="Search-Icon" />
//                 )}
//                 <input
//                     placeholder="Search your business category"
//                     value={search}
//                     onChange={(e) => handleChange(e.target.value)}
//                     onFocus={() => {
//                         setShowList(true);
//                         setIsFocused(true);
//                     }}
//                     onBlur={() => {
//                         setTimeout(() => setShowList(false), 200);
//                         setIsFocused(false);
//                         setTouched(true);
//                     }}
//                 />
//             </div>

//             {error && touched && (
//                 <p className={styles.errorText}>{error}</p>
//             )}

//             {showList && (
//                 <div className={styles.list}>
//                     {filteredList.map((item, i) => (
//                         <div
//                             key={i}
//                             className={styles.listItem}
//                             onMouseDown={() => handleSelect(item)}
//                         >
//                             {item.display}
//                         </div>
//                     ))}

//                     {isNewCategory && (
//                         <div
//                             className={`${styles.listItem} ${styles.newItem}`}
//                             onMouseDown={handleSelectNew}
//                         >
//                             {search}
//                             <span className={styles.newTag}>New</span>
//                         </div>
//                     )}
//                 </div>
//             )}
//         </>
//     );
// });

// export default StepOne;

import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef, useMemo } from "react";
import styles from './BusinessStep.module.css';
import { validateField } from "../../utils/validation";
import { businessTypes } from "../../lib/businessCategories";
import DEFAULT_BUSINESS_VERTICALS from "../../lib/defaultBusinessVerticals";
import { trackEvent } from "../../lib/analytics";

// GA4: wait this long after the user stops typing before logging the search
// term — one clean business_category_search per term, not per keystroke.
const SEARCH_TRACK_DEBOUNCE_MS = 800;

const CATEGORY_ICONS = {
    "Plumber": "svg/Plumber.svg",
    "HVAC Services": "svg/Home-Services.svg",
    "Roofers": "svg/Roofer.svg",
    "Restaurant": "svg/Restaurant-icon.svg",
    "Real Estate Broker": "svg/Estate-icon.svg",
    "Salon": "svg/Saloon-icon.svg",
    "General Contractor": "svg/GeneralConstructor.svg",
};
const FALLBACK_ICON = "svg/Home-Services.svg";
// Icon shown for user-added custom categories (the "Add <new>" flow).
const NEW_CATEGORY_ICON = "svg/add_new_icon.svg";

// How long the search-box loader spins after a category is picked, before the
// green check appears. Change this number to adjust the duration (ms).
const SELECT_LOADER_MS = 300;

const StepOne = forwardRef(({ data, updateData, setIsFocused, onBusinessTypeChange }, ref) => {
    const [search, setSearch] = useState(data?.businessSubtype || data?.businessType || "");
    const [showList, setShowList] = useState(true);
    const [error, setError] = useState("");
    const [touched, setTouched] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    // ── Confirmation modal state ──────────────────────────
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmedCategory, setConfirmedCategory] = useState("");
    const confirmTimerRef = useRef(null);

    // User-added custom categories (from "Add <new>") — prepended so they sit at
    // the top of Popular Categories.
    const [customCategories, setCustomCategories] = useState([]);

    const inputRef = useRef(null);
    const listRef = useRef(null);
    const containerRef = useRef(null);
    const searchBoxRef = useRef(null);
    const stickyHeaderRef = useRef(null);    // the sticky floating header wrapper
    const stickySentinelRef = useRef(null);  // marker above it → detects "stuck"
    const [isStuck, setIsStuck] = useState(false);
    const [inputFocused, setInputFocused] = useState(false);

    // Search-box loader: spins for SELECT_LOADER_MS right after a category is
    // picked, then the green check appears.
    const [selectLoading, setSelectLoading] = useState(false);
    const selectLoaderTimer = useRef(null);
    const startSelectLoader = () => {
        setSelectLoading(true);
        if (selectLoaderTimer.current) clearTimeout(selectLoaderTimer.current);
        selectLoaderTimer.current = setTimeout(() => setSelectLoading(false), SELECT_LOADER_MS);
    };
    useEffect(() => () => {
        if (selectLoaderTimer.current) clearTimeout(selectLoaderTimer.current);
    }, []);
    // Header shows its floating shadow while scrolled (stuck) OR while typing.
    const headerElevated = isStuck || inputFocused;

    // Nearest actually-scrollable ancestor (the onboarding step's scroll area).
    const getScrollParent = (node) => {
        let p = node?.parentElement;
        while (p) {
            const oy = getComputedStyle(p).overflowY;
            if ((oy === "auto" || oy === "scroll") && p.scrollHeight > p.clientHeight) return p;
            p = p.parentElement;
        }
        return null;
    };

    // Toggle the "stuck" shadow: a 1px sentinel sits just above the header; once
    // it scrolls out of the scroll viewport the header is pinned at top:0.
    useEffect(() => {
        const sentinel = stickySentinelRef.current;
        const header = stickyHeaderRef.current;
        if (!sentinel || !header || typeof IntersectionObserver === "undefined") return;
        const root = getScrollParent(header) || null;
        const observer = new IntersectionObserver(
            ([entry]) => setIsStuck(!entry.isIntersecting),
            { root, threshold: 0 }
        );
        observer.observe(sentinel);
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // On focus, smooth-scroll so the sticky header lands exactly at the top
    // (top:0) of the step's scroll area. We scroll the scroll container directly
    // by the measured delta — far more reliable on iOS Safari / Android than
    // scrollIntoView — and never touch the input, so it stays focused and the
    // keyboard opens. The bar sits at the TOP, so the bottom keyboard can't cover
    // it. Skips when already aligned (no flicker).
    const STICKY_OFFSET = 0; // header pins at top:0
    const scrollSearchToTop = () => {
        const run = () => {
            const el = stickyHeaderRef.current;
            if (!el) return;
            const scrollParent = getScrollParent(el);
            if (!scrollParent) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
            const delta =
                el.getBoundingClientRect().top -
                scrollParent.getBoundingClientRect().top -
                STICKY_OFFSET;
            if (Math.abs(delta) <= 2) return; // already at the top → skip
            scrollParent.scrollTo({
                top: scrollParent.scrollTop + delta,
                behavior: "smooth",
            });
        };
        // Re-align across several passes. A single late pass loses the race
        // against the mobile browser's own "scroll focused input into view"
        // (which re-centers the field) that fires after the keyboard opens.
        // Each pass is a no-op once the bar is already at the top, so retrying
        // is cheap and just wins whichever frame the keyboard settles on.
        requestAnimationFrame(run);
        [150, 350, 550, 800].forEach((ms) => setTimeout(run, ms));
    };

    // Ticker placeholder state (groups built below from allCategories).
    const [tickerIndex, setTickerIndex] = useState(0);
    const showAnimatedPlaceholder = search === "";

    // ── Load from data prop ───────────────────────────────
    useEffect(() => {
        if (data?.businessSubtype) setSearch(data.businessSubtype);
        else if (data?.businessType) setSearch(data.businessType);
    }, [data?.businessSubtype, data?.businessType]);

    // On mount, if a previously-selected category is a CUSTOM one (not a known
    // businessType), re-seed it so it shows (selected) at the top of the list.
    useEffect(() => {
        const bt = (data?.businessType || "").trim();
        if (!bt) return;
        const inBase = businessTypes.some((t) => t.type.toLowerCase() === bt.toLowerCase());
        if (!inBase) {
            setCustomCategories([{ display: bt, type: bt, subtype: data?.businessSubtype || null, isMainType: true, icon: NEW_CATEGORY_ICON }]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ── Outside click ─────────────────────────────────────
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setHighlightedIndex(-1);
                setIsFocused(false);
                setTouched(true);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, []);

    // ── Cleanup confirm timer on unmount ──────────────────
    useEffect(() => {
        return () => {
            if (confirmTimerRef.current) clearTimeout(confirmTimerRef.current);
        };
    }, []);

    // ── Build searchable list ─────────────────────────────
    const buildSearchableList = () => {
        const items = [];
        const seen = new Set();
        businessTypes.forEach((bt) => {
            const mainType = bt.type;
            if (bt.subtypes && bt.subtypes.length > 0) {
                bt.subtypes.forEach((sub) => {
                    const key = sub.toLowerCase();
                    if (!seen.has(key)) {
                        seen.add(key);
                        items.push({ display: sub, type: mainType, subtype: sub, isMainType: false, icon: bt.icon });
                    }
                });
            }
            const mainTypeKey = mainType.toLowerCase();
            if (!seen.has(mainTypeKey)) {
                seen.add(mainTypeKey);
                items.push({ display: mainType, type: mainType, subtype: null, isMainType: true, icon: bt.icon });
            }
        });
        return items;
    };

    const searchableList = buildSearchableList();

    const baseCategories = businessTypes
        .map((bt) =>
            searchableList.find(
                (item) => item.display.toLowerCase() === bt.type.toLowerCase()
            )
        )
        .filter(Boolean);

    // Custom categories sit at the very top of the Popular Categories list.
    const allCategories = [...customCategories, ...baseCategories];

    // ── Animated placeholder ticker ───────────────────────
    // Built from the SAME list shown in the grid (allCategories) so the search
    // box only cycles categories that actually exist — 3 at a time.
    const categoryGroups = useMemo(() => {
        const names = allCategories.map((item) => item.display);
        const groups = [];
        for (let i = 0; i < names.length; i += 3) {
            const line = names
                .slice(i, i + 3)
                .map((n) => `"${n.toLowerCase()}"`)
                .join(", ");
            groups.push(line);
        }
        return groups;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const groupCount = categoryGroups.length;

    useEffect(() => {
        if (!showAnimatedPlaceholder || groupCount <= 1) return;
        const id = setInterval(() => {
            setTickerIndex((i) => (i + 1) % groupCount);
        }, 2000);
        return () => clearInterval(id);
    }, [showAnimatedPlaceholder, groupCount]);

    const trimmedSearch = search.trim();
    const isExactCategory = allCategories.some(
        (item) => item.display.toLowerCase() === trimmedSearch.toLowerCase()
    );
    const baseList =
        trimmedSearch === "" || isExactCategory
            ? allCategories
            : allCategories.filter((item) =>
                item.display.toLowerCase().includes(search.toLowerCase())
            );

    // Selecting a category does NOT reorder the list — the picked one keeps its
    // original position (custom-added ones already sit at the top via allCategories).
    const filteredList = baseList;
    const isNewCategory = trimmedSearch !== "" && filteredList.length === 0;
    const totalItems = filteredList.length + (isNewCategory ? 1 : 0);

    // Live validation of whatever is currently typed (emojis, special chars,
    // excessively long / random / meaningless input). Drives the inline error,
    // hides the "Add" box and the green check while the value is invalid.
    const categoryError =
        trimmedSearch !== "" ? (validateField("businessType", search) || "") : "";
    const searchIsInvalid = categoryError !== "";

    // ── Highlighted item scroll into view ────────────────
    useEffect(() => {
        if (highlightedIndex >= 0 && listRef.current) {
            const item = listRef.current.children[highlightedIndex];
            if (item) item.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
    }, [highlightedIndex]);

    // ── Reset highlight on search change ─────────────────
    useEffect(() => {
        setHighlightedIndex(-1);
    }, [search]);

    // While the "Add new category" dropdown is open, lock the background scroll
    // so the page behind can't move under the dropdown. Restored on close/unmount.
    useEffect(() => {
        const active = isNewCategory && !searchIsInvalid;
        const sp = getScrollParent(stickyHeaderRef.current);
        if (!sp) return;
        sp.style.overflow = active ? "hidden" : "";
        return () => { sp.style.overflow = ""; };
    }, [isNewCategory, searchIsInvalid]);

    // ── Show confirmation helper ──────────────────────────
    // Stays visible until the user dismisses it (cross) — no auto-hide.
    const triggerConfirm = (categoryName) => {
        setConfirmedCategory(categoryName);
        setShowConfirm(true);
    };

    // ── GA4: search tracking ──────────────────────────────
    // business_category_search must fire ONCE before business_category_selected
    // so the search→select funnel is always complete — even when the user never
    // typed and just picked a category straight from the list (a "browse").
    //   • Typed 2+ chars, paused        → search_term = <text>, method: "typed"
    //   • Selected without searching     → search_term = "",     method: "browse"
    // A pending typed search is flushed on select so a fast type→click still logs
    // the real term instead of dropping it.
    const searchTrackTimer = useRef(null);
    const searchFiredRef = useRef(false); // did a search event already go out?
    useEffect(() => () => {
        if (searchTrackTimer.current) clearTimeout(searchTrackTimer.current);
    }, []);
    const fireSearchEvent = (term, method) => {
        searchFiredRef.current = true;
        trackEvent("business_category_search", {
            search_term: (term || "").trim().toLowerCase(),
            method,
        });
    };
    const queueSearchTrack = (term) => {
        if (searchTrackTimer.current) clearTimeout(searchTrackTimer.current);
        const clean = (term || "").trim().toLowerCase();
        if (clean.length < 2) return; // ignore empty / single-letter noise
        searchTrackTimer.current = setTimeout(() => fireSearchEvent(clean, "typed"), SEARCH_TRACK_DEBOUNCE_MS);
    };
    // Call right before a selection: guarantees a search event has fired.
    const ensureSearchTracked = () => {
        // A typed search is still waiting out its debounce → flush it now with
        // the real term instead of losing it to the select.
        if (searchTrackTimer.current) {
            clearTimeout(searchTrackTimer.current);
            searchTrackTimer.current = null;
            if (!searchFiredRef.current) {
                fireSearchEvent(trimmedSearch, "typed");
                return;
            }
        }
        if (searchFiredRef.current) return; // already logged a search
        // User browsed the list and picked without searching → log a browse so
        // the funnel still shows search → select.
        fireSearchEvent(trimmedSearch, trimmedSearch ? "typed" : "browse");
    };

    // ── Handlers ─────────────────────────────────────────
    const handleChange = (rawValue) => {
        // Cap the category text at 30 characters (covers paste too).
        const value = (rawValue || "").slice(0, 30);
        setSearch(value);
        queueSearchTrack(value); // GA4: log the search term after typing pauses
        setShowList(true);
        setShowConfirm(false); // typing again → hide the confirmation
        // Mobile: closing the keyboard doesn't blur the input, so onFocus won't
        // fire when the user scrolls down and types again. Re-align on type too.
        // The delta<=2 guard inside makes this a no-op when already at the top.
        scrollSearchToTop();
        if (data.businessType) {
            updateData({ businessType: '', businessSubtype: '', customBusiness: '' });
            if (onBusinessTypeChange) onBusinessTypeChange(1);
        }
        if (touched) {
            const err = validateField('businessType', value);
            setError(err || "");
        }
    };

    const applySelection = (item, { keepOpen }) => {
        const hasChanged = data.businessType && data.businessType !== item.type;
        if (hasChanged && onBusinessTypeChange) onBusinessTypeChange(1);
        ensureSearchTracked(); // fire search→ (browse if user never searched) BEFORE select
        // GA4: the user picked a category from the grid/list. source tells us
        // whether they found it by browsing or via the search box. An exact
        // match in the box means a previous selection is showing → browsing.
        trackEvent("business_category_selected", {
            category: item.type,
            subtype: item.subtype || "",
            source: trimmedSearch === "" || isExactCategory ? "browse_list" : "search_result",
        });
        setSearch(item.display);
        setError("");
        startSelectLoader(); // search box: loader first, then green check
        updateData({ businessType: item.type, businessSubtype: item.subtype, customBusiness: "" });
        if (!keepOpen) {
            setShowList(false);
            setIsFocused(false);
            setHighlightedIndex(-1);
            // Confirm box no longer pops on selection — it shows on Continue.
        }
    };

    // Selecting a category keeps the list open — the picked one shows its
    // selected state while all the other categories stay visible.
    const handleSelect = (item) => applySelection(item, { keepOpen: true });

    // Hover only highlights the card (visual). It must NOT select — the label,
    // the search box and the businessType only change on an actual click.
    // Skipped on touch devices (no real hover) so tapping never flashes a
    // highlight — mobile shows state only on tap/select.
    const handleCardHover = (item, i) => {
        if (typeof window !== "undefined" && window.matchMedia &&
            !window.matchMedia("(hover: hover)").matches) return;
        setHighlightedIndex(i);
    };

    const handleSelectNew = () => {
        // Validate the custom-typed category before adding it (blocks emojis,
        // special characters, excessively long / random / meaningless input).
        setTouched(true);
        const err = validateField('businessType', search);
        if (err) {
            setError(err);
            return;
        }
        const name = search.trim();

        // Dedup: if it already exists, just select it (no duplicate entry).
        const existing = allCategories.find(
            (item) => item.display.toLowerCase() === name.toLowerCase()
        );
        const item = existing || { display: name, type: name, subtype: null, isMainType: true, icon: NEW_CATEGORY_ICON };

        // New one → add to the TOP of Popular Categories (alongside the rest).
        if (!existing) setCustomCategories((prev) => [item, ...prev]);

        ensureSearchTracked(); // custom add = they typed → flush the real search first
        // GA4: user added their own category (not in our list) and selected it.
        trackEvent("business_category_selected", {
            category: item.type,
            subtype: item.subtype || "",
            source: existing ? "search_result" : "custom_added",
        });

        // Auto-select it. Keep the list open so it shows (selected) at the top
        // with the other categories.
        const hasChanged = data.businessType && data.businessType !== item.type;
        if (hasChanged && onBusinessTypeChange) onBusinessTypeChange(1);
        setSearch(item.display);
        setError("");
        setHighlightedIndex(-1);
        startSelectLoader(); // search box: loader first, then green check
        updateData({
            businessType: item.type,
            businessSubtype: item.subtype,
            customBusiness: existing ? "" : name,
        });
    };

    // Mobile: while the input is focused (soft keyboard open), tapping anywhere
    // outside the search box (the category list / background) dismisses the
    // keyboard by blurring the input — focus leaves the input.
    const handleTouchOutsideInput = (e) => {
        const box = searchBoxRef.current;
        if (box && box.contains(e.target)) return; // tap inside search box → keep typing
        if (inputRef.current && document.activeElement === inputRef.current) {
            inputRef.current.blur();
        }
    };

    // ── Keyboard handler ──────────────────────────────────
    const handleKeyDown = (e) => {
        switch (e.key) {
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                if (!showList) {
                    setShowList(true);
                    setHighlightedIndex(0);
                } else {
                    setHighlightedIndex((prev) => prev < totalItems - 1 ? prev + 1 : 0);
                }
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                if (!showList) {
                    setShowList(true);
                    setHighlightedIndex(totalItems - 1);
                } else {
                    setHighlightedIndex((prev) => prev > 0 ? prev - 1 : totalItems - 1);
                }
                break;
            case "Tab":
                e.preventDefault();
                if (highlightedIndex >= 0 && highlightedIndex < filteredList.length) {
                    handleSelect(filteredList[highlightedIndex]);
                } else if (isNewCategory && highlightedIndex === filteredList.length) {
                    handleSelectNew();
                } else {
                    setShowList(false);
                    setIsFocused(false);
                }
                break;
            case "Enter":
                if (showList && highlightedIndex >= 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (highlightedIndex < filteredList.length) {
                        handleSelect(filteredList[highlightedIndex]);
                    } else if (isNewCategory) {
                        handleSelectNew();
                    }
                } else if (showList && highlightedIndex === -1 && filteredList.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSelect(filteredList[0]);
                }
                break;
            case "Escape":
                setShowList(false);
                setHighlightedIndex(-1);
                break;
            default:
                break;
        }
    };

    // ── Expose validate to parent ─────────────────────────
    useImperativeHandle(ref, () => ({
        validate: () => {
            setTouched(true);
            const effective = (search.trim() || data.businessType || "").trim();
            const err = validateField('businessType', effective);
            setError(err || "");
            if (!err) {
                const matchedItem = searchableList.find(
                    (item) => item.display.toLowerCase() === effective.toLowerCase()
                );
                if (matchedItem) {
                    const hasChanged = data.businessType && data.businessType !== matchedItem.type;
                    updateData({ businessType: matchedItem.type, businessSubtype: matchedItem.subtype, customBusiness: "" });
                    if (hasChanged && onBusinessTypeChange) setTimeout(() => onBusinessTypeChange(1), 0);
                } else {
                    const hasChanged = data.businessType && data.businessType !== effective;
                    updateData({ businessType: effective, businessSubtype: null, customBusiness: effective });
                    if (hasChanged && onBusinessTypeChange) setTimeout(() => onBusinessTypeChange(1), 0);
                }
                return true;
            }
            return false;
        }
    }));

    return (
        <div ref={containerRef} className={styles.stepRoot} onTouchStart={handleTouchOutsideInput}>
            {/* Dim the whole step behind the "Add new category" dropdown. The
                sticky search header + dropdown sit above this (higher z-index). */}
            {isNewCategory && !searchIsInvalid && (
                <div className={styles.categoryOverlay} aria-hidden="true" />
            )}

            <div className={styles.titleBar}>
                <h4 className={styles.lightTitle}>What kind of </h4>
                <h5 className={styles.boldTitle}>business is this?</h5>
                <p className={styles.subtitle}>
                   This helps Rexpt understand your business and handle calls better.
                </p>
            </div>

            {/* Sentinel marks where the header begins; once it scrolls out of
                view the header is "stuck" and we add the floating shadow. */}
            <div ref={stickySentinelRef} className={styles.stickySentinel} aria-hidden="true" />

            <div
                ref={stickyHeaderRef}
                className={`${styles.stickyHeader} ${headerElevated ? styles.stickyHeaderStuck : ""}`}
            >
                <div className={styles.searchBox} ref={searchBoxRef}>
                    {search === "" && (
                        <img src="svg/Search-Icon.svg" alt="Search-Icon" />
                    )}
                    <div className={styles.inputWrap}>
                        <input
                            ref={inputRef}
                            placeholder=""
                            maxLength={30}
                            value={search}
                            onChange={(e) => handleChange(e.target.value)}
                            onKeyDown={handleKeyDown}
                            onFocus={() => {
                                setShowList(true);
                                setIsFocused(true);
                                setInputFocused(true); // keep the header shadow while typing
                                setShowConfirm(false); // re-engaging → hide the confirmation
                                scrollSearchToTop();   // bring search bar to top of viewport
                            }}
                            onBlur={() => setInputFocused(false)}
                        />

                        {showAnimatedPlaceholder && (
                            <div className={styles.animatedPlaceholder} aria-hidden="true">
                                <span className={styles.placeholderStatic}>Search e.g.</span>
                                <div className={styles.tickerViewport}>
                                    <span key={tickerIndex} className={styles.tickerItem}>
                                        {categoryGroups[tickerIndex]}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* After selecting: loader spins first, then the green check. */}
                    {(data.businessType || "").trim() !== "" && !searchIsInvalid && (
                        selectLoading ? (
                            <div className={`newloader ${styles.searchLoader}`} aria-hidden="true" />
                        ) : (
                            <svg className={styles.searchCheck} width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.75 0.75L6.25 11.25L0.75 5.75" stroke="#08BF57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        )
                    )}

                    {/* No match → "Add new category" box, absolutely positioned
                        as a dropdown just below the search box (small gap). */}
                    {isNewCategory && !searchIsInvalid && (
                        <div className={styles.noMatchWrap}>
                            <p className={styles.noMatchText}>
                                No exact match found for{" "}
                                <span className={styles.noMatchHighlight}>"{search}"</span>
                            </p>
                            <p className={styles.noMatchSub}>You can add it as a new category</p>
                            <div className={styles.addBoxNew} onClick={handleSelectNew}>
                                <span className={styles.addBoxPlus}>+</span>
                                <span>Add "{search}"</span>
                            </div>
                        </div>
                    )}
                </div>

                {/* Validation error shown inside the sticky header, right below
                    the search box (kept out of the categories area below). */}
                {(searchIsInvalid || (error && touched)) && (
                    <p className={`${styles.errorText} ${styles.searchError}`}>{searchIsInvalid ? categoryError : error}</p>
                )}
            </div>

            {showList && (
                <div className={styles.popularWrap}>
                    <p className={styles.popularTitle}>
                        {trimmedSearch === "" ? "Popular business types" : "Popular business types"}
                    </p>

                    <div className={styles.cardGrid} ref={listRef}>
                        {(isNewCategory && !searchIsInvalid ? allCategories : filteredList).map((item, i) => {
                            const selected = search.toLowerCase() === item.display.toLowerCase();
                            return (
                                <div
                                    key={i}
                                    className={`${styles.categoryCard} ${selected ? styles.cardSelected : ""} ${highlightedIndex === i ? styles.cardHighlighted : ""}`}
                                    onClick={() => handleSelect(item)}
                                    onMouseEnter={() => handleCardHover(item, i)}
                                >
                                    <img
                                        className={styles.cardIcon}
                                        src={item.icon || CATEGORY_ICONS[item.display] || FALLBACK_ICON}
                                        alt=""
                                        aria-hidden="true"
                                        onError={(e) => {
                                            if (!e.currentTarget.dataset.fallback) {
                                                e.currentTarget.dataset.fallback = "1";
                                                e.currentTarget.src = FALLBACK_ICON;
                                            }
                                        }}
                                    />
                                    <span className={styles.cardLabel}>{item.display}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* ── Category Selected Confirmation (inline, not a modal) ──
                Stays visible until the user clicks the cross. */}
            {showConfirm && (
                <div className={styles.confirmBox} role="status">
                    <button
                        className={styles.confirmClose}
                        onClick={() => {
                            // Close the confirmation, clear the selection (empties the
                            // search box + hides the green check) and reopen the full list.
                            const hadType = !!(data.businessType || "").trim();
                            setShowConfirm(false);
                            setSearch("");
                            setShowList(true);
                            updateData({ businessType: "", businessSubtype: "", customBusiness: "" });
                            if (hadType && onBusinessTypeChange) onBusinessTypeChange(1);
                        }}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                    <div className={styles.confirmCheckWrap}>
                        <div className={styles.confirmCheck}>✓</div>
                    </div>
                    <p className={styles.confirmTitle}>Category selected!</p>
                    <p className={styles.confirmSub}>your business category has been set as:</p>
                    <p className={styles.confirmCat}>"{confirmedCategory}"</p>
                </div>
            )}
        </div>
    );
});

export default StepOne;
